import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import FeaturedProjects from '../components/FeaturedProjects';
import GoogleReviews from '../components/GoogleReviews';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import FloatingContactWidget from '../components/FloatingContactWidget';
import ContactActions from '../components/ContactActions';
import { useTheme } from '../contexts/ThemeContext';

const HomePage = () => {
    const { isDark } = useTheme();
    return (
        <div className={`overflow-x-hidden ${isDark ? 'bg-gray-900' : 'bg-white'} transition-colors duration-300`}>
            <Navbar />
            <Hero />
            <ContactActions />
            <GoogleReviews />
            <FeaturedProjects />
            <Services />
            <About />
            <Contact />
            <Footer />
            <FloatingContactWidget />
        </div>
    );
};

export default HomePage;
